import { useLocation, useNavigate } from "react-router-dom";

// Safe "back" for header back-buttons. If the current route was entered directly
// (deep link, reload, PWA shortcut, payment redirect, notification) there is no in-app
// history, and navigate(-1) would leave the SPA to about:blank (blank/frozen screen).
// React Router v6 marks the initial entry with location.key === "default".
export function useSafeBack(fallback = "/lineage") {
  const location = useLocation();
  const navigate = useNavigate();
  return () => {
    if (location.key && location.key !== "default") navigate(-1);
    else navigate(fallback, { replace: true });
  };
}
